import React, { createContext, useContext, useMemo } from 'react';
import { useNowNextInterval } from '../../../hooks/useNowNextInterval';

type DeckContentSwitchingValue = {
  showNextProgram: boolean;
};

const DeckContentSwitchingContext = createContext<DeckContentSwitchingValue>({
  showNextProgram: false,
});

export function useDeckContentSwitching(): DeckContentSwitchingValue {
  return useContext(DeckContentSwitchingContext);
}

export function DeckContentSwitchingProvider({
  intervalMs,
  children,
}: React.PropsWithChildren<{ intervalMs: number | null | undefined }>): React.ReactElement {
  const { showNextProgram } = useNowNextInterval(intervalMs);
  const value = useMemo(() => ({ showNextProgram }), [showNextProgram]);

  return (
    <DeckContentSwitchingContext.Provider value={value}>
      {children}
    </DeckContentSwitchingContext.Provider>
  );
}
